module.exports = __webpack_public_path__ + "static/gardener-lady-desktop-d10b42c29eec733a8bbe40abb3f48233.jpg";